import { Controller } from "@hotwired/stimulus"

// Drives a native <dialog> as a confirmation modal. Put the trigger button and
// the <dialog data-confirm-dialog-target="dialog"> inside one element with
// data-controller="confirm-dialog". The dialog's own buttons (Cancel / the
// real submit) call close — submit is a normal button_to form, so the request
// fires before the dialog tears down.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  close(event) {
    if (event) event.preventDefault()
    this.dialogTarget.close()
  }

  // Close when the user clicks the backdrop (outside the dialog's content box).
  backdropClose(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }
}
